import React from 'react';
import SecondChartCard from './components/SecondChartCard';

const SecondChartLayout  = () => {
        return <SecondChartCard />
}

export default React.memo(SecondChartLayout);
